const _temp0 = require("../../react-aria-components/stories/Button.stories.tsx");

const _temp1 = require("../../react-aria-components/stories/Calendar.stories.tsx");

const _temp2 = require("../../react-aria-components/stories/ComboBox.stories.tsx");

const _temp3 = require("../../react-aria-components/stories/DateField.stories.tsx");

const _temp4 = require("../../react-aria-components/stories/DatePicker.stories.tsx");

const _temp5 = require("../../react-aria-components/stories/Dropzone.stories.tsx");

const _temp6 = require("../../react-aria-components/stories/FileTrigger.stories.tsx");

const _temp7 = require("../../react-aria-components/stories/Link.stories.tsx");

const _temp8 = require("../../react-aria-components/stories/ListBox.stories.tsx");

const _temp9 = require("../../react-aria-components/stories/Menu.stories.tsx");

const _temp10 = require("../../react-aria-components/stories/Meter.stories.tsx");

const _temp11 = require("../../react-aria-components/stories/Modal.stories.tsx");

const _temp12 = require("../../react-aria-components/stories/NumberField.stories.tsx");

const _temp13 = require("../../react-aria-components/stories/Popover.stories.tsx");

const _temp14 = require("../../react-aria-components/stories/ProgressBar.stories.tsx");

const _temp15 = require("../../react-aria-components/stories/RadioGroup.stories.tsx");

const _temp16 = require("../../react-aria-components/stories/SearchField.stories.tsx");

const _temp17 = require("../../react-aria-components/stories/Select.stories.tsx");

const _temp18 = require("../../react-aria-components/stories/Slider.stories.tsx");

const _temp19 = require("../../react-aria-components/stories/Switch.stories.tsx");

const _temp20 = require("../../react-aria-components/stories/Table.stories.tsx");

const _temp21 = require("../../react-aria-components/stories/Tabs.stories.tsx");

const _temp22 = require("../../react-aria-components/stories/TagGroup.stories.tsx");

const _temp23 = require("../../react-aria-components/stories/TextField.stories.tsx");

const _temp24 = require("../../react-aria-components/stories/TimeField.stories.tsx");

const _temp25 = require("../../react-aria-components/stories/ToggleButton.stories.tsx");

const _temp26 = require("../../react-aria-components/stories/Toolbar.stories.tsx");

const _temp27 = require("../../react-aria-components/stories/Tooltip.stories.tsx");

const _temp28 = require("../../react-aria-components/stories/Tree.stories.tsx");

const _temp29 = require("../../react-aria-components/stories/animations.stories.tsx");


const _temp30 = require("../../@react-spectrum/accordion/stories/Accordion.stories.tsx");


const _temp31 = require("../../@react-spectrum/actiongroup/stories/ActionGroup.stories.tsx");

const _temp32 = require("../../@react-spectrum/actiongroup/stories/Toolbar.stories.tsx");


const _temp33 = require("../../@react-spectrum/actionbar/stories/ActionBar.stories.tsx");


const _temp34 = require("../../@react-spectrum/autocomplete/stories/SearchAutocomplete.stories.tsx");


const _temp35 = require("../../@react-spectrum/avatar/stories/Avatar.stories.tsx");


const _temp36 = require("../../@react-spectrum/badge/stories/Badge.stories.tsx");


const _temp37 = require("../../@react-spectrum/breadcrumbs/stories/Breadcrumbs.stories.tsx");


const _temp38 = require("../../@react-spectrum/button/stories/ActionButton.stories.tsx");

const _temp39 = require("../../@react-spectrum/button/stories/Button.stories.tsx");

const _temp40 = require("../../@react-spectrum/button/stories/LogicButton.stories.tsx");

const _temp41 = require("../../@react-spectrum/button/stories/ToggleButton.stories.tsx");


const _temp42 = require("../../@react-spectrum/buttongroup/stories/ButtonGroup.stories.tsx");


const _temp43 = require("../../@react-spectrum/calendar/stories/Calendar.stories.tsx");

const _temp44 = require("../../@react-spectrum/calendar/stories/RangeCalendar.stories.tsx");

const _temp45 = require("../../@react-spectrum/calendar/stories/RangeCalendarCell.stories.tsx");


const _temp46 = require("../../@react-spectrum/card/stories/Card.stories.tsx");

const _temp47 = require("../../@react-spectrum/card/stories/GalleryCardView.stories.tsx");

const _temp48 = require("../../@react-spectrum/card/stories/GridCardView.stories.tsx");

const _temp49 = require("../../@react-spectrum/card/stories/HorizontalCard.stories.tsx");

const _temp50 = require("../../@react-spectrum/card/stories/QuietCard.stories.tsx");

const _temp51 = require("../../@react-spectrum/card/stories/WaterfallCardView.stories.tsx");


const _temp52 = require("../../@react-spectrum/checkbox/stories/Checkbox.stories.tsx");

const _temp53 = require("../../@react-spectrum/checkbox/stories/CheckboxGroup.stories.tsx");


const _temp54 = require("../../@react-spectrum/color/stories/ColorArea.stories.tsx");

const _temp55 = require("../../@react-spectrum/color/stories/ColorField.stories.tsx");

const _temp56 = require("../../@react-spectrum/color/stories/ColorSlider.stories.tsx");

const _temp57 = require("../../@react-spectrum/color/stories/ColorThumb.stories.tsx");

const _temp58 = require("../../@react-spectrum/color/stories/ColorWheel.stories.tsx");


const _temp59 = require("../../@react-spectrum/combobox/stories/ComboBox.stories.tsx");


const _temp60 = require("../../@react-spectrum/contextualhelp/stories/ContextualHelp.stories.tsx");


const _temp61 = require("../../@react-spectrum/datepicker/stories/DateField.stories.tsx");

const _temp62 = require("../../@react-spectrum/datepicker/stories/DatePicker.stories.tsx");

const _temp63 = require("../../@react-spectrum/datepicker/stories/DateRangePicker.stories.tsx");

const _temp64 = require("../../@react-spectrum/datepicker/stories/DateRangePickerStyling.stories.tsx");

const _temp65 = require("../../@react-spectrum/datepicker/stories/TimeField.stories.tsx");

const _temp66 = require("../../@react-spectrum/datepicker/stories/TimeFieldStyling.stories.tsx");


const _temp67 = require("../../@react-spectrum/dialog/stories/AlertDialog.stories.tsx");

const _temp68 = require("../../@react-spectrum/dialog/stories/Dialog.stories.tsx");

const _temp69 = require("../../@react-spectrum/dialog/stories/DialogContainer.stories.tsx");

const _temp70 = require("../../@react-spectrum/dialog/stories/DialogTrigger.stories.tsx");


const _temp71 = require("../../@react-spectrum/divider/stories/Divider.stories.tsx");


const _temp72 = require("../../@react-spectrum/dropzone/stories/DropZone.stories.tsx");

const _temp73 = require("../../@react-spectrum/dropzone/stories/FileTrigger.stories.tsx");


const _temp74 = require("../../@react-spectrum/form/stories/Form.stories.tsx");


const _temp75 = require("../../@react-spectrum/icon/stories/Icon.stories.tsx");


const _temp76 = require("../../@react-spectrum/illustratedmessage/stories/IllustratedMessage.stories.tsx");


const _temp77 = require("../../@react-spectrum/image/stories/Image.stories.tsx");


const _temp78 = require("../../@react-spectrum/inlinealert/stories/InlineAlert.stories.tsx");


const _temp79 = require("../../@react-spectrum/label/stories/HelpText.stories.tsx");

const _temp80 = require("../../@react-spectrum/label/stories/Label.stories.tsx");


const _temp81 = require("../../@react-spectrum/labeledvalue/stories/LabeledValue.stories.tsx");


const _temp82 = require("../../@react-spectrum/layout/stories/Flex.stories.tsx");

const _temp83 = require("../../@react-spectrum/layout/stories/Grid.stories.tsx");


const _temp84 = require("../../@react-spectrum/link/stories/Link.stories.tsx");


const _temp85 = require("../../@react-spectrum/list/stories/ListView.stories.tsx");

const _temp86 = require("../../@react-spectrum/list/stories/ListViewActions.stories.tsx");

const _temp87 = require("../../@react-spectrum/list/stories/ListViewDnD.stories.tsx");

const _temp88 = require("../../@react-spectrum/list/stories/ListViewDnDUtil.stories.tsx");

const _temp89 = require("../../@react-spectrum/list/stories/ListViewSelection.stories.tsx");


const _temp90 = require("../../@react-spectrum/listbox/stories/ListBox.stories.tsx");


const _temp91 = require("../../@react-spectrum/menu/stories/ActionMenu.stories.tsx");

const _temp92 = require("../../@react-spectrum/menu/stories/MenuTrigger.stories.tsx");

const _temp93 = require("../../@react-spectrum/menu/stories/Submenu.stories.tsx");


const _temp94 = require("../../@react-spectrum/meter/stories/Meter.stories.tsx");


const _temp95 = require("../../@react-spectrum/numberfield/stories/NumberField.stories.tsx");


const _temp96 = require("../../@react-spectrum/overlays/stories/Modal.stories.tsx");


const _temp97 = require("../../@react-spectrum/pagination/stories/pagination.stories.js");


const _temp98 = require("../../@react-spectrum/picker/stories/Picker.stories.tsx");


const _temp99 = require("../../@react-spectrum/progress/stories/ProgressBar.stories.tsx");

const _temp100 = require("../../@react-spectrum/progress/stories/ProgressCircle.stories.tsx");


const _temp101 = require("../../@react-spectrum/provider/stories/Provider.stories.tsx");


const _temp102 = require("../../@react-spectrum/radio/stories/Radio.stories.tsx");


const _temp103 = require("../../@react-spectrum/searchfield/stories/SearchField.stories.tsx");


const _temp104 = require("../../@react-spectrum/searchwithin/stories/SearchWithin.stories.tsx");


const _temp105 = require("../../@react-spectrum/slider/stories/RangeSlider.stories.tsx");

const _temp106 = require("../../@react-spectrum/slider/stories/Slider.stories.tsx");


const _temp107 = require("../../@react-spectrum/statuslight/stories/StatusLight.stories.tsx");


const _temp108 = require("../../@react-spectrum/steplist/stories/StepList.stories.tsx");


const _temp109 = require("../../@react-spectrum/style-macro-s1/stories/StyleMacro.stories.tsx");


const _temp110 = require("../../@react-spectrum/switch/stories/Switch.stories.tsx");


const _temp111 = require("../../@react-spectrum/table/stories/Table.stories.tsx");

const _temp112 = require("../../@react-spectrum/table/stories/TableDnD.stories.tsx");

const _temp113 = require("../../@react-spectrum/table/stories/TableDnDUtil.stories.tsx");

const _temp114 = require("../../@react-spectrum/table/stories/TreeGridTable.stories.tsx");


const _temp115 = require("../../@react-spectrum/tabs/stories/Tabs.stories.tsx");


const _temp116 = require("../../@react-spectrum/tag/stories/TagGroup.stories.tsx");


const _temp117 = require("../../@react-spectrum/textfield/stories/TextArea.stories.tsx");

const _temp118 = require("../../@react-spectrum/textfield/stories/Textfield.stories.tsx");


const _temp119 = require("../../@react-spectrum/toast/stories/Toast.stories.tsx");


const _temp120 = require("../../@react-spectrum/tooltip/stories/Tooltip.stories.tsx");

const _temp121 = require("../../@react-spectrum/tooltip/stories/TooltipTrigger.stories.tsx");


const _temp122 = require("../../@react-spectrum/tree/stories/TreeView.stories.tsx");


const _temp123 = require("../../@react-spectrum/view/stories/View.stories.tsx");


const _temp124 = require("../../@react-spectrum/well/stories/Well.stories.tsx");



const _temp125 = require("../../@react-aria/button/stories/useButton.stories.tsx");


const _temp126 = require("../../@react-aria/calendar/stories/useCalendar.stories.tsx");


const _temp127 = require("../../@react-aria/combobox/stories/useComboBox.stories.tsx");


const _temp128 = require("../../@react-aria/dnd/stories/dnd.stories.tsx");


const _temp129 = require("../../@react-aria/focus/stories/FocusScope.stories.tsx");


const _temp130 = require("../../@react-aria/grid/stories/useGrid.stories.tsx");


const _temp131 = require("../../@react-aria/interactions/stories/useFocusRing.stories.tsx");

const _temp132 = require("../../@react-aria/interactions/stories/useHover.stories.tsx");

const _temp133 = require("../../@react-aria/interactions/stories/useInteractOutside.stories.tsx");

const _temp134 = require("../../@react-aria/interactions/stories/useMove.stories.tsx");


const _temp135 = require("../../@react-aria/label/stories/useField.stories.tsx");


const _temp136 = require("../../@react-aria/landmark/stories/Landmark.stories.tsx");


const _temp137 = require("../../@react-aria/menu/stories/useMenu.stories.tsx");


const _temp138 = require("../../@react-aria/overlays/stories/UseOverlayPosition.stories.tsx");

const _temp139 = require("../../@react-aria/overlays/stories/useModal.stories.tsx");

const _temp140 = require("../../@react-aria/overlays/stories/usePreventScroll.stories.tsx");


const _temp141 = require("../../@react-aria/select/stories/useSelect.stories.tsx");


const _temp142 = require("../../@react-aria/selection/stories/useSelectableList.stories.tsx");


const _temp143 = require("../../@react-aria/slider/stories/Slider.stories.tsx");


const _temp144 = require("../../@react-aria/table/stories/useTable.stories.tsx");


const _temp145 = require("../../@react-aria/tabs/stories/useTabList.stories.tsx");


const _temp146 = require("../../@react-aria/textfield/stories/useTextField.stories.tsx");


const _temp147 = require("../../@react-aria/toast/stories/useToast.stories.tsx");


const _temp148 = require("../../@react-aria/utils/stories/platform.stories.tsx");



const _temp149 = require("../../@react-stately/tree/stories/useTreeState.stories.tsx");



const _temp150 = require("../../@spectrum-icons/color/stories/IconsColor.stories.tsx");


const _temp151 = require("../../@spectrum-icons/express/stories/IconsExpress.stories.tsx");


const _temp152 = require("../../@spectrum-icons/workflow/stories/IconsWorkflow.stories.tsx");



module.exports = {
  "react-aria-components":   {
    "Button":     {
      "tsx": _temp0
    },
    "Calendar":     {
      "tsx": _temp1
    },
    "ComboBox":     {
      "tsx": _temp2
    },
    "DateField":     {
      "tsx": _temp3
    },
    "DatePicker":     {
      "tsx": _temp4
    },
    "Dropzone":     {
      "tsx": _temp5
    },
    "FileTrigger":     {
      "tsx": _temp6
    },
    "Link":     {
      "tsx": _temp7
    },
    "ListBox":     {
      "tsx": _temp8
    },
    "Menu":     {
      "tsx": _temp9
    },
    "Meter":     {
      "tsx": _temp10
    },
    "Modal":     {
      "tsx": _temp11
    },
    "NumberField":     {
      "tsx": _temp12
    },
    "Popover":     {
      "tsx": _temp13
    },
    "ProgressBar":     {
      "tsx": _temp14
    },
    "RadioGroup":     {
      "tsx": _temp15
    },
    "SearchField":     {
      "tsx": _temp16
    },
    "Select":     {
      "tsx": _temp17
    },
    "Slider":     {
      "tsx": _temp18
    },
    "Switch":     {
      "tsx": _temp19
    },
    "Table":     {
      "tsx": _temp20
    },
    "Tabs":     {
      "tsx": _temp21
    },
    "TagGroup":     {
      "tsx": _temp22
    },
    "TextField":     {
      "tsx": _temp23
    },
    "TimeField":     {
      "tsx": _temp24
    },
    "ToggleButton":     {
      "tsx": _temp25
    },
    "Toolbar":     {
      "tsx": _temp26
    },
    "Tooltip":     {
      "tsx": _temp27
    },
    "Tree":     {
      "tsx": _temp28
    },
    "animations":     {
      "tsx": _temp29
    }
  },
  "@react-spectrum":   {
    "accordion":     {
      "Accordion":       {
        "tsx": _temp30
      }
    },
    "actiongroup":     {
      "ActionGroup":       {
        "tsx": _temp31
      },
      "Toolbar":       {
        "tsx": _temp32
      }
    },
    "actionbar":     {
      "ActionBar":       {
        "tsx": _temp33
      }
    },
    "autocomplete":     {
      "SearchAutocomplete":       {
        "tsx": _temp34
      }
    },
    "avatar":     {
      "Avatar":       {
        "tsx": _temp35
      }
    },
    "badge":     {
      "Badge":       {
        "tsx": _temp36
      }
    },
    "breadcrumbs":     {
      "Breadcrumbs":       {
        "tsx": _temp37
      }
    },
    "button":     {
      "ActionButton":       {
        "tsx": _temp38
      },
      "Button":       {
        "tsx": _temp39
      },
      "LogicButton":       {
        "tsx": _temp40
      },
      "ToggleButton":       {
        "tsx": _temp41
      }
    },
    "buttongroup":     {
      "ButtonGroup":       {
        "tsx": _temp42
      }
    },
    "calendar":     {
      "Calendar":       {
        "tsx": _temp43
      },
      "RangeCalendar":       {
        "tsx": _temp44
      },
      "RangeCalendarCell":       {
        "tsx": _temp45
      }
    },
    "card":     {
      "Card":       {
        "tsx": _temp46
      },
      "GalleryCardView":       {
        "tsx": _temp47
      },
      "GridCardView":       {
        "tsx": _temp48
      },
      "HorizontalCard":       {
        "tsx": _temp49
      },
      "QuietCard":       {
        "tsx": _temp50
      },
      "WaterfallCardView":       {
        "tsx": _temp51
      }
    },
    "checkbox":     {
      "Checkbox":       {
        "tsx": _temp52
      },
      "CheckboxGroup":       {
        "tsx": _temp53
      }
    },
    "color":     {
      "ColorArea":       {
        "tsx": _temp54
      },
      "ColorField":       {
        "tsx": _temp55
      },
      "ColorSlider":       {
        "tsx": _temp56
      },
      "ColorThumb":       {
        "tsx": _temp57
      },
      "ColorWheel":       {
        "tsx": _temp58
      }
    },
    "combobox":     {
      "ComboBox":       {
        "tsx": _temp59
      }
    },
    "contextualhelp":     {
      "ContextualHelp":       {
        "tsx": _temp60
      }
    },
    "datepicker":     {
      "DateField":       {
        "tsx": _temp61
      },
      "DatePicker":       {
        "tsx": _temp62
      },
      "DateRangePicker":       {
        "tsx": _temp63
      },
      "DateRangePickerStyling":       {
        "tsx": _temp64
      },
      "TimeField":       {
        "tsx": _temp65
      },
      "TimeFieldStyling":       {
        "tsx": _temp66
      }
    },
    "dialog":     {
      "AlertDialog":       {
        "tsx": _temp67
      },
      "Dialog":       {
        "tsx": _temp68
      },
      "DialogContainer":       {
        "tsx": _temp69
      },
      "DialogTrigger":       {
        "tsx": _temp70
      }
    },
    "divider":     {
      "Divider":       {
        "tsx": _temp71
      }
    },
    "dropzone":     {
      "DropZone":       {
        "tsx": _temp72
      },
      "FileTrigger":       {
        "tsx": _temp73
      }
    },
    "form":     {
      "Form":       {
        "tsx": _temp74
      }
    },
    "icon":     {
      "Icon":       {
        "tsx": _temp75
      }
    },
    "illustratedmessage":     {
      "IllustratedMessage":       {
        "tsx": _temp76
      }
    },
    "image":     {
      "Image":       {
        "tsx": _temp77
      }
    },
    "inlinealert":     {
      "InlineAlert":       {
        "tsx": _temp78
      }
    },
    "label":     {
      "HelpText":       {
        "tsx": _temp79
      },
      "Label":       {
        "tsx": _temp80
      }
    },
    "labeledvalue":     {
      "LabeledValue":       {
        "tsx": _temp81
      }
    },
    "layout":     {
      "Flex":       {
        "tsx": _temp82
      },
      "Grid":       {
        "tsx": _temp83
      }
    },
    "link":     {
      "Link":       {
        "tsx": _temp84
      }
    },
    "list":     {
      "ListView":       {
        "tsx": _temp85
      },
      "ListViewActions":       {
        "tsx": _temp86
      },
      "ListViewDnD":       {
        "tsx": _temp87
      },
      "ListViewDnDUtil":       {
        "tsx": _temp88
      },
      "ListViewSelection":       {
        "tsx": _temp89
      }
    },
    "listbox":     {
      "ListBox":       {
        "tsx": _temp90
      }
    },
    "menu":     {
      "ActionMenu":       {
        "tsx": _temp91
      },
      "MenuTrigger":       {
        "tsx": _temp92
      },
      "Submenu":       {
        "tsx": _temp93
      }
    },
    "meter":     {
      "Meter":       {
        "tsx": _temp94
      }
    },
    "numberfield":     {
      "NumberField":       {
        "tsx": _temp95
      }
    },
    "overlays":     {
      "Modal":       {
        "tsx": _temp96
      }
    },
    "pagination":     {
      "pagination":       {
        "js": _temp97
      }
    },
    "picker":     {
      "Picker":       {
        "tsx": _temp98
      }
    },
    "progress":     {
      "ProgressBar":       {
        "tsx": _temp99
      },
      "ProgressCircle":       {
        "tsx": _temp100
      }
    },
    "provider":     {
      "Provider":       {
        "tsx": _temp101
      }
    },
    "radio":     {
      "Radio":       {
        "tsx": _temp102
      }
    },
    "searchfield":     {
      "SearchField":       {
        "tsx": _temp103
      }
    },
    "searchwithin":     {
      "SearchWithin":       {
        "tsx": _temp104
      }
    },
    "slider":     {
      "RangeSlider":       {
        "tsx": _temp105
      },
      "Slider":       {
        "tsx": _temp106
      }
    },
    "statuslight":     {
      "StatusLight":       {
        "tsx": _temp107
      }
    },
    "steplist":     {
      "StepList":       {
        "tsx": _temp108
      }
    },
    "style-macro-s1":     {
      "StyleMacro":       {
        "tsx": _temp109
      }
    },
    "switch":     {
      "Switch":       {
        "tsx": _temp110
      }
    },
    "table":     {
      "Table":       {
        "tsx": _temp111
      },
      "TableDnD":       {
        "tsx": _temp112
      },
      "TableDnDUtil":       {
        "tsx": _temp113
      },
      "TreeGridTable":       {
        "tsx": _temp114
      }
    },
    "tabs":     {
      "Tabs":       {
        "tsx": _temp115
      }
    },
    "tag":     {
      "TagGroup":       {
        "tsx": _temp116
      }
    },
    "textfield":     {
      "TextArea":       {
        "tsx": _temp117
      },
      "Textfield":       {
        "tsx": _temp118
      }
    },
    "toast":     {
      "Toast":       {
        "tsx": _temp119
      }
    },
    "tooltip":     {
      "Tooltip":       {
        "tsx": _temp120
      },
      "TooltipTrigger":       {
        "tsx": _temp121
      }
    },
    "tree":     {
      "TreeView":       {
        "tsx": _temp122
      }
    },
    "view":     {
      "View":       {
        "tsx": _temp123
      }
    },
    "well":     {
      "Well":       {
        "tsx": _temp124
      }
    }
  },
  "@react-aria":   {
    "button":     {
      "useButton":       {
        "tsx": _temp125
      }
    },
    "calendar":     {
      "useCalendar":       {
        "tsx": _temp126
      }
    },
    "combobox":     {
      "useComboBox":       {
        "tsx": _temp127
      }
    },
    "dnd":     {
      "dnd":       {
        "tsx": _temp128
      }
    },
    "focus":     {
      "FocusScope":       {
        "tsx": _temp129
      }
    },
    "grid":     {
      "useGrid":       {
        "tsx": _temp130
      }
    },
    "interactions":     {
      "useFocusRing":       {
        "tsx": _temp131
      },
      "useHover":       {
        "tsx": _temp132
      },
      "useInteractOutside":       {
        "tsx": _temp133
      },
      "useMove":       {
        "tsx": _temp134
      }
    },
    "label":     {
      "useField":       {
        "tsx": _temp135
      }
    },
    "landmark":     {
      "Landmark":       {
        "tsx": _temp136
      }
    },
    "menu":     {
      "useMenu":       {
        "tsx": _temp137
      }
    },
    "overlays":     {
      "UseOverlayPosition":       {
        "tsx": _temp138
      },
      "useModal":       {
        "tsx": _temp139
      },
      "usePreventScroll":       {
        "tsx": _temp140
      }
    },
    "select":     {
      "useSelect":       {
        "tsx": _temp141
      }
    },
    "selection":     {
      "useSelectableList":       {
        "tsx": _temp142
      }
    },
    "slider":     {
      "Slider":       {
        "tsx": _temp143
      }
    },
    "table":     {
      "useTable":       {
        "tsx": _temp144
      }
    },
    "tabs":     {
      "useTabList":       {
        "tsx": _temp145
      }
    },
    "textfield":     {
      "useTextField":       {
        "tsx": _temp146
      }
    },
    "toast":     {
      "useToast":       {
        "tsx": _temp147
      }
    },
    "utils":     {
      "platform":       {
        "tsx": _temp148
      }
    }
  },
  "@react-stately":   {
    "tree":     {
      "useTreeState":       {
        "tsx": _temp149
      }
    }
  },
  "@spectrum-icons":   {
    "color":     {
      "IconsColor":       {
        "tsx": _temp150
      }
    },
    "express":     {
      "IconsExpress":       {
        "tsx": _temp151
      }
    },
    "workflow":     {
      "IconsWorkflow":       {
        "tsx": _temp152
      }
    }
  }
}